"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingMessage = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_select_1 = require("react-select");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var CircularProgress_1 = tslib_1.__importDefault(require("@material-ui/core/CircularProgress"));
var theme_1 = require("../../../theme");
exports.LoadingMessage = function (props) {
    return (react_1.default.createElement(StyledReactSelectLoadingMessage, tslib_1.__assign({}, props),
        react_1.default.createElement(StyledCircularProgress, { size: "1.6rem", thickness: 5 })));
};
exports.LoadingMessage.displayName = 'FOS_ReactSelect_LoadingMessage';
var StyledReactSelectLoadingMessage = styled_components_1.default(react_select_1.components.LoadingMessage)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  && {\n    padding: 1rem 0;\n  }\n"], ["\n  && {\n    padding: 1rem 0;\n  }\n"])));
var StyledCircularProgress = styled_components_1.default(CircularProgress_1.default)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  && {\n    color: ", ";\n  }\n"], ["\n  && {\n    color: ", ";\n  }\n"])), theme_1.theme.colors.aqua[600]);
var templateObject_1, templateObject_2;
